import React, { ReactElement } from 'react';
import clsx from 'clsx';
import { Dialog, makeStyles } from '@material-ui/core';
import BtnClose from '../BtnClose';

interface ModalBaseWhiteProps {
  className?: string;
  open: boolean;
  onClose: () => void;
  children: ReactElement;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
}

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: '10px',
    fontFamily: 'Inter',
    fontSize: '14px',
    color: '#2A2D3C',
    minWidth: '100vw',
    minHeight: '120vw',
    background: '#FFF',
    [theme.breakpoints.up('lg')]: {
      minHeight: '120vw',
    },
  },
  btnClose: {
    marginLeft: 'auto',
  },
}));

export default function ModalBaseWhite(
  props: ModalBaseWhiteProps
): ReactElement {
  const { className, open, onClose, children, maxWidth } = props;
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      aria-labelledby="responsive-dialog-title"
      onClose={onClose}
      maxWidth={maxWidth}
      PaperProps={{
        className: clsx(classes.root, className),
      }}
    >
      <div style={{ width: 600, margin: 'auto' }}>{children}</div>
    </Dialog>
  );
}

ModalBaseWhite.defaultProps = {
  className: '',
  maxWidth: 'xs',
};
